import {defineAsyncComponent} from "vue";

export const siteConfig = {
    luckin: {
        name: "瑞幸咖啡",
        type: "luckin",
        title: "川航金熊猫里程兑换瑞幸代金券",
        banner: require("@/assets/images/luckin/banner.png"),
        components: {
            product: {
                view: defineAsyncComponent(() => import("@/components/luckin/LuckinProductLstComponents.vue")
                ),
                title: "川航金熊猫里程兑换瑞幸代金券"
            },
            order: {
                view: defineAsyncComponent(() => import("@/components/luckin/LuckinOrderComponents.vue")),
                title: "川航金熊猫里程兑换瑞幸代金券"
            },
        },
        style: {
            home: {
                "--theme-background": "#D0E5FF",
                "--theme-btn-text-color":"#2A48A8",
                "--copy-right": "#808080"
            }
        }
    },
    shuyi: {
        name: "书亦烧仙草",
        type: "shuyi",
        title: "川航金熊猫里程兑换书亦烧仙草优惠券",
        banner: require("@/assets/images/shuyi/banner.png"),
        components: {
            product: {
                view: defineAsyncComponent(() => import("@/components/shuyi/ShuyiProductLstComponents.vue")
                ),
                title: "川航金熊猫里程兑换书亦烧仙草优惠券"
            },
            order: {
                view: defineAsyncComponent(() => import("@/components/shuyi/ShuyiOrderComponents.vue")),
                title: "川航金熊猫里程兑换书亦烧仙草优惠券"
            },
        },
        style: {
            home: {
                "--theme-background": "#C1DEB0",
                "--theme-btn-text-color":"#A6D63F",
                "--copy-right": "#808080"
            }
        }
    },
    douyin: {
        name: "抖音",
        type: "douyin",
        title: "川航金熊猫里程兑换抖音生活服务券",
        banner: require("@/assets/images/douyin/banner.png"),
        components: {
            product: {
                view: defineAsyncComponent(() => import("@/components/douyin/DouyinProductComponents.vue")
                ),
                title: "川航金熊猫里程兑换抖音生活服务券"
            },
            order: {
                view: defineAsyncComponent(() => import("@/components/douyin/DouyinOrderComponents.vue")),
                title: "川航金熊猫里程兑换抖音生活服务券"
            },
        },
        style: {
            home: {
                "--theme-background": "#D40212",
                "--theme-btn-text-color":"#FF8D1A",
                "--copy-right": "#ffffff"
            }
        }
    },
    qiaopai: {
        name: "延长壳牌",
        type: "qiaopai",
        title: "川航金熊猫里程兑换四川壳牌加油券",
        banner: require("@/assets/images/qiaopai/banner.png"),
        components: {
            product: {
                view: defineAsyncComponent(() => import("@/components/qiaopai/QiaopaiProductLstComponents.vue")
                ),
                title: "川航金熊猫里程兑换四川壳牌加油券"
            },
            order: {
                view: defineAsyncComponent(() => import("@/components/qiaopai/QiaopaiOrderComponents.vue")),
                title: "川航金熊猫里程兑换四川壳牌加油券"
            },
        },
        style: {
            home: {
                "--theme-background": "#FFD008",
                "--theme-btn-text-color":"#EA2838",
                "--copy-right": "#ffffff"
            }
        }
    },
    nakebao: {
        name: "全家/德克士",
        type: "nakebao",
        title: "川航金熊猫里程兑换全家/德克士优惠券",
        banner: require("@/assets/images/nakebao/banner.png"),
        components: {
            product: {
                view: defineAsyncComponent(() => import("@/components/nakebao/NakebaoProductLstComponents.vue")
                ),
                title: "川航金熊猫里程兑换全家/德克士优惠券"
            },
            order: {
                view: defineAsyncComponent(() => import("@/components/nakebao/NakebaoOrderComponents.vue")),
                title: "川航金熊猫里程兑换全家/德克士优惠券"
            },
        },
        style: {
            home: {
                "--theme-background": "#BFE8BA",
                "--theme-btn-text-color":"#49A43B",
                "--copy-right": "#808080"
            }
        }
    },
    shuangke: {
        name: "爽客按摩椅",
        type: "shuangke",
        title: "川航金熊猫里程兑换爽客按摩券",
        banner: require("@/assets/images/shuangke/scal-banner.png"),
        components: {
            product: {
                view: defineAsyncComponent(() => import("@/components/shuangke/ShuangkeProductComponents.vue")
                ),
                title: "川航金熊猫里程兑换爽客按摩券"
            },
            order: {
                view: defineAsyncComponent(() => import("@/components/shuangke/ShuangkeOrderComponents.vue")),
                title: "川航金熊猫里程兑换爽客按摩券"
            },
        },
        style: {
            home: {
                "--theme-background": "#F3EAEA",
                "--theme-btn-text-color":"#F03739",
                "--copy-right": "#000"
            }
        }
    },
    'shuangke-xmair': {
        name: "爽客按摩椅",
        type: "shuangke",
        login: "xm_air",
        title: "白鹭积分兑换爽客按摩券",
        banner: require("@/assets/images/shuangke/xmair-banner.png"),
        components: {
            product: {
                view: defineAsyncComponent(() => import("@/components/shuangke/ShuangkeProductComponents.vue")
                ),
                title: "白鹭积分兑换爽客按摩券"
            },
            order: {
                view: defineAsyncComponent(() => import("@/components/shuangke/ShuangkeOrderComponents.vue")),
                title: "白鹭积分兑换爽客按摩券"
            },
        },
        style: {
            home: {
                "--theme-background": "#F3EAEA",
                "--theme-btn-text-color":"#F03739",
                "--copy-right": "#000"
            }
        }
    },
    fandeng: {
        name: "樊登读书",
        type: "fandeng",
        login: "scal",
        title: "川航金熊猫里程兑换樊登读书会员卡",
        banner: require("@/assets/images/fandeng/banner.png"),
        components: {
            product: {
                view: defineAsyncComponent(() => import("@/components/fandeng/FdIndexComponent.vue")
                ),
                title: "川航金熊猫里程兑换樊登读书会员卡"
            },
            order: {
                view: defineAsyncComponent(() => import("@/components/fandeng/FdOrderComponent.vue")),
                title: "川航金熊猫里程兑换樊登读书会员卡"
            },
        },
        style: {
            home: {
                "--theme-background": "#FAEAAE",
                "--theme-btn-text-color":"#D1AC0F",
                "--copy-right": "#000"
            }
        }
    },
}
